import { Component } from '@angular/core';
import { take, catchError } from 'rxjs/operators';
import { Warehouse } from '../../models/warehouse.model';
import { WarehouseService } from '../../services/warehouse.service';
import { WarehouseValidatorService } from '../../validators/warehouse-validator.service';

@Component({
    selector: 'app-warehouses-new',
    templateUrl: './warehouses-new.component.html',
    styleUrls: ['./warehouses-new.component.scss'],
    standalone: false
})
export class WarehousesNewComponent {

  warehouse: Warehouse = new Warehouse();

  isError: boolean = false;
  isServerError: boolean = false;

  constructor(private warehouseValidator: WarehouseValidatorService,
    private warehouseService: WarehouseService) { }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;

    if (this.warehouseValidator.isValid(this.warehouse)) {
      this.warehouseService.createWarehouse(this.warehouse)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        window.location.href = '/warehousing/warehouses';
      })
    } else {
      this.isError = true;
    }
  }
}
